import { useState } from 'react';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import infoDarkIcon from 'src/assets/icons/info-dark.svg';
import infoWhiteIcon from 'src/assets/icons/info-white.svg';

import { I18NextNS } from 'src/models/Language.model';

export default function OrderDetailsButton({
  onClick,
}: {
  onClick: () => void;
}) {
  const { t } = useTranslation(I18NextNS.COMMON);

  const [isHovered, setIsHovered] = useState(false);
  return (
    <Button
      variant="outline-primary"
      className="rounded-3 px-3 py-1"
      onClick={onClick}
      aria-label={t('orderDetails.viewDetails')}
      data-test="order-details-view-button"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <img
        src={isHovered ? infoWhiteIcon : infoDarkIcon}
        style={{ height: '1.2em', width: 'auto', marginBottom: '0.1em' }}
      />
    </Button>
  );
}
